import { Icon } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';

type Props = {
  financialBlockade: boolean | null;
};

export function FinantialBlockTooltip({ financialBlockade }: Props) {
  const { t } = useTranslation();
  return (
    <div className="mb-4">
      {financialBlockade === null && (
        <p className="text-dark d-flex align-items-center">
          <Icon className="mr-2" name="information" size="15px" />
          {t(
            'studentManagement.academicHistory.tabs.titulation.finantialBlock.nullBlock',
          )}
        </p>
      )}
      {financialBlockade === true && (
        <p className="text-dark d-flex align-items-center">
          <Icon className="mr-2" name="error" color="danger" size="15px" />
          {t(
            'studentManagement.academicHistory.tabs.titulation.finantialBlock.activeBlock',
          )}
        </p>
      )}
      {financialBlockade === false && (
        <p className="text-dark d-flex align-items-center">
          <Icon className="mr-2" name="success" color="success" size="15px" />
          {t(
            'studentManagement.academicHistory.tabs.titulation.finantialBlock.falseBlock',
          )}
        </p>
      )}
    </div>
  );
}
